import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M8 2C4.692 2 2 4.692 2 8s2.692 6 6 6 6-2.692 6-6-2.692-6-6-6m0 10.8A4.806 4.806 0 0 1 3.2 8c0-2.647 2.153-4.8 4.8-4.8s4.8 2.153 4.8 4.8-2.153 4.8-4.8 4.8" }, null, -1),
    _createElementVNode("path", { d: "M6.8 8.952 5.42 7.575l-.847.85L6.8 10.648l4.023-4.024-.848-.848z" }, null, -1)
  ]))]))
}
export default { render: render }